import { makeStyles } from "@material-ui/core";

export const leadTimeWidgetStyle = makeStyles((theme) => ({
    count: {
        fontSize: '2em',
        fontWeight: 700,
        textAlign: 'left'
    },
    graphWrapper: {
        height: '100%',
        minHeight: '20rem',
        position: 'relative'
    },
    container: {
        minHeight: "120px",
        maxHeight: "120px",
        alignItems: "stretch !important"
    },
    graphTootltip: {
        background: 'white',
        padding: '0.5em 1em',
        borderRadius: '5px',
        boxShadow: '1px 2px 7px #ddd'
    },
    latestData: {
        width: '95%',
        marginLeft: '1rem',
        marginTop: '0.5rem',
        height: '25%'
    },
    latestDataText: {
        fontSize: 11,
        fontWeight: 500,
        marginBottom: '5px'

    },
    data: {
        height: '35px',
        borderRadius: '4px',
        paddingLeft: '10px',
        width: '49%',
        lineHeight: '1.2',
    },
    average: {
        backgroundColor: '#ebf5fe',
        color: '#1e88e5'
    },
    stDev: {
        backgroundColor: '#fdf2d0',
        color: '#b8912f'
    },
    hours: {
        paddingLeft: '5px',
        fontSize: 14,
        fontWeight: 800,
    },
    name: {
        paddingLeft: '5px',
        fontSize: 8,
        fontWeight: 500,
    }
}));